import actions from '@/store/modules/project/actions.js'
import getters from '@/store/modules/project/getters.js'
import mutations from '@/store/modules/project/mutations.js'

/**
 * @returns {object}
 */
const getDefaultState = () => ({
  projects: []
})

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}

export { getDefaultState }
